import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import MantenimientoHero from "./components/MantenimientoHero";
import MantenimientoIntro from "./components/MantenimientoIntro";
import MantenimientoBenefits from "./components/MantenimientoBenefits";
import MantenimientoWhyChoose from "./components/MantenimientoWhyChoose";
import MantenimientoCta from "./components/MantenimientoCta";

export default function MantenimientoCuartosFrios() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <MantenimientoHero />
        <MantenimientoIntro />
        <MantenimientoBenefits />
        <MantenimientoWhyChoose />
        <MantenimientoCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}